import { useMemo } from 'react';
import isDate from 'lodash/isDate';
import isFunction from 'lodash/isFunction';
import { Collections, SubCollections } from '../../firebase/firestore/collections';
import { RecruiterBasedAppointment } from '../../firebase/firestore/documents/candidate';
import { useSubDocumentSnapshot } from '../../firebase/firestore/hooks';

export interface UpcomingAppointment {
  appointment: RecruiterBasedAppointment;
}

function toDate(value: unknown): Date | undefined {
  // istanbul ignore next
  if (!value) return undefined;

  if (isDate(value)) {
    return value;
  }

  const timestamp = value as firebase.firestore.Timestamp;

  // eslint-disable-next-line @typescript-eslint/unbound-method
  if (value && isFunction(timestamp?.toDate)) {
    return (value as firebase.firestore.Timestamp).toDate();
  }

  return new Date(value as string);
}

export function useUpcomingAppointment(candidateId: string): UpcomingAppointment | undefined {
  const appointmentDocument = useSubDocumentSnapshot<RecruiterBasedAppointment>(
    Collections.CANDIDATES,
    SubCollections.APPOINTMENT,
    candidateId,
    'current',
  );

  return useMemo(() => {
    if (!appointmentDocument) {
      return undefined;
    }

    return {
      appointment: {
        ...appointmentDocument,
        fromDate: toDate(appointmentDocument.fromDate),
        toDate: appointmentDocument.toDate ? toDate(appointmentDocument.toDate) : /* istanbul ignore next */ undefined,
      },
    };
  }, [appointmentDocument]);
}
